import { useRef, useState } from "react";
import PropTypes from "prop-types";
import { MenuOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useUser } from "../../contexts/UserContext/UserContext";
import LanguageSelector from "../language/language_selector";
import ActionsSearchField from "../../features/dashboard/components/ActionsSearchField";
import AllActionsModal from "../../features/dashboard/components/AllActionsModal";
import useActionGroups from "../../features/dashboard/components/useActionGroups";

const GlassPageTopBar = ({ title, rightContent, onOpenMenu }) => {
    const { t } = useTranslation("topBar");
    const { t: tDashboard } = useTranslation("dashboard");
    const { state } = useUser();
    const { actionGroups } = useActionGroups();
    const [isAllActionsOpen, setIsAllActionsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const topBarInputRef = useRef(null);
    const searchFieldRef = useRef(null);

    const resolvedTitle =
        title ??
        t("welcomeMessage", {
            userEmail: state?.user?.id && state?.user?.email,
        });

    const openAllActions = () => {
        topBarInputRef.current?.blur();
        setIsAllActionsOpen(true);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        if (!isAllActionsOpen) {
            topBarInputRef.current?.blur();
            setIsAllActionsOpen(true);
        }
    };

    const handleCloseAllActions = () => {
        setIsAllActionsOpen(false);
        setSearchTerm("");
    };

    return (
        <div className="sticky top-4 z-20 w-full shrink-0 box-border">
            <div
                className="flex h-16 items-center justify-between gap-4 rounded-full border border-[#5D5DF6]/10 bg-[#5C5DF6]/5 px-5 backdrop-blur-sm backdrop-saturate-150 xl:px-6"
                data-tour="page-top-bar">
                <span className="fontSemi truncate text-base text-[#2F2F46] xl:text-lg">{resolvedTitle}</span>
                <div className="flex shrink-0 items-center justify-end gap-2 xl:gap-4">
                    {rightContent ?? (
                        <>
                            <ActionsSearchField
                                ref={searchFieldRef}
                                inputRef={topBarInputRef}
                                value={searchTerm}
                                onChange={handleSearchChange}
                                onFocus={openAllActions}
                                onClick={openAllActions}
                                placeholder={tDashboard("searchActionsPlaceholder")}
                                className="hidden w-64 py-2 sm:flex xl:w-80"
                            />
                            <LanguageSelector defaultLanguage="en" />
                            {onOpenMenu ? (
                                <Button
                                    type="text"
                                    aria-label="Open menu"
                                    icon={<MenuOutlined className="text-lg text-[#2F2F46]" />}
                                    onClick={onOpenMenu}
                                    className="!flex !h-10 !w-10 !min-w-10 items-center justify-center !rounded-full hover:!bg-[#5D5DF6]/10 lg:!hidden"
                                />
                            ) : null}
                        </>
                    )}
                </div>
            </div>
            {!rightContent && (
                <AllActionsModal
                    open={isAllActionsOpen}
                    onClose={handleCloseAllActions}
                    actionGroups={actionGroups}
                    initialSearchTerm={searchTerm}
                    anchorRef={searchFieldRef}
                />
            )}
        </div>
    );
};

GlassPageTopBar.propTypes = {
    title: PropTypes.node,
    rightContent: PropTypes.node,
    onOpenMenu: PropTypes.func,
};

export default GlassPageTopBar;
